<div class="contenedor-principal" *ngIf="(datosRecibidos2) && errorMessage === ''">
    <div class="caja-establecimientos" routerLink="/dispositivos">
        <h2 class="titulo-establecimientos"><i class="material-icons icono-establecimiento">store</i>DISPOSITIVOS</h2>
        <div class="contenido-establecimientos">
            <span class="numero-establecimientos">{{ nDispositivos }}</span>
        </div>
    </div>

    <div class="caja-alarmas">
        <h2 class="titulo-alarmas" [routerLink]="['/alarmas/activas']"><i class="material-icons icono-establecimiento">warning</i>
            <span class="numero-alarmas">{{ nAlarmasSinPresion}}</span> ALARMAS ACTIVAS
        </h2>
        <div class="contenido-alarmas">
            <div class="contenedor-boton">
                <button class="boton-alarma" [routerLink]="['/alarmas/activas']" [state]="{ tipo: 1 }">
                    <i class="material-icons">local_drink</i>
                    <div class="alarma-texto">
                        <span>NIVEL</span>
                        <span class="contador-valor">{{contadorAlarmaNivel}}</span>
                    </div>            
                </button>
                <span  *ngIf="(userData.pro_id == 4 || userData.pro_id == 2 || userData.pro_id == 1) && dispositivosConAlarmasNivel.length !== 0" class="icono-circular" (click)="abrirDialogoRecargas('400ms','200ms'); $event.stopPropagation()">
                    <mat-icon class="icon-icono-circular">autorenew</mat-icon>
                </span>
            </div>
            <div>
                <button class="boton-alarma" [routerLink]="['/alarmas/activas']" [state]="{ tipo: 2 }">
                    <i class="material-icons">thermostat</i>
                    <div class="alarma-texto">
                        <span>TEMPERATURA</span>
                        <span class="contador-valor">{{ contadorAlarmaTemperatura }}</span>
                    </div>
                </button>
            </div>
            <div>
                <button class="boton-alarma" [routerLink]="['/alarmas/activas']" [state]="{ tipo: 3 }">
                    <i class="material-icons">wifi</i>
                    <div class="alarma-texto">
                        <span>CONEXIÓN</span>
                        <span class="contador-valor">{{ contadorAlarmaConexion }}</span>
                    </div>
                </button>
            </div>
            <div>
                <button class="boton-alarma" [routerLink]="['/alarmas/activas']" [state]="{ tipo: 4 }">
                    <div class="alarma-texto">
                        <span><i class="material-icons">insert_chart</i>HARDWARE</span>
                        <span class="contador-valor">{{ contadorOtras }}</span>
                    </div>
                </button>
            </div>
        </div>        
    </div>
    </div>
<div class="row" *ngIf="(datosRecibidos2) && errorMessage === ''">
    <!-- <div class="ripple-container1" matRipple>
        <div>
            <i class="material-icons ripple-icon1">devices_other</i>
            <div class="datos-rc ripple-datos-margin1">
                <span class="containerTittle"><br>Nº DISPOSITIVOS</span>
                <span class="containerNDispositivosNDispositivos">{{nDispositivos}}</span>
            </div>
        </div>
    </div>
    <button mat-stroked-button (click)="openDialog('400ms', '200ms')" class="ripple-container2">
        <div>
            <i class="material-icons ripple-icon2">notifications</i>
            <div class="datos-rc ripple-datos-margin2">
                <span class="containerTittle"><br>ALARMAS ACT.</span>
                <span class="containerNDispositivosNAlarmas">{{nAlarmas}}</span>
            </div>
        </div>
    </button>
    <div class="ripple-container3" matRipple>
        <div>
            <i class="material-icons ripple-icon3">date_range</i>
            <div class="datos-rc ripple-datos-margin3">
                <span class="containerTittle"><br>HOY ES</span>
                <span class="containerNDispositivosFecha">{{sFechaActual}}</span>
            </div>
        </div>
    </div>
    <div class="ripple-container4" matRipple>
        <div>
            <i class="material-icons ripple-icon1">access_time</i>
            <div class="datos-rc ripple-datos-margin4">
                <span class="containerTittle"><br>HORA LOCAL</span>
                <span class="containerNDispositivosHora">{{ time | date: 'HH:mm:ss' }}</span>
            </div>
        </div>
    </div> -->

    <div class="leyenda-info">
        <!--<mat-expansion-panel hideToggle class="leyenda-expansion-panel">
            <mat-expansion-panel-header>
              <mat-panel-title class="leyenda-panel-tittle">
                Info. leyendas
              </mat-panel-title>
              
            </mat-expansion-panel-header>
            <p>This is the primary content of the panel.</p>
        </mat-expansion-panel>-->

        <!--AUTOCOMPLETE-->
        <div class="autocomplete">
            <form>
                <mat-form-field class="autocompleteForm">
                    <mat-label>Dispositivo</mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input type="text"
                            placeholder="Elige uno"
                            aria-label="Dispositivo"
                            matInput
                            [formControl]="myControl"
                            [matAutocomplete]="auto">
                    <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn" (optionSelected)="onOptionSelected($event)">
                        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                            {{ option.name }} ({{ option.reference }})
                        </mat-option>
                    </mat-autocomplete>
                    <button *ngIf="myControl.value != ''" matSuffix mat-icon-button aria-label="Clear" (click)="limpiarSeleccion()">
                        <mat-icon>close</mat-icon>
                    </button>
                </mat-form-field>
            </form>
        </div>
        <div class="lado-derecho">
            
        </div>
        <!--FILTROS-->
        <mat-form-field appearance ="outline" class="select-estado">
            <mat-label class="filtros-tittle">FILTROS</mat-label>
            <mat-select [(ngModel)]="selectedStatus" (selectionChange)="onStatusChange()">
                <mat-option value="todos">Todos</mat-option>
                <mat-option value="normal">Sin Alarmas</mat-option>
                <mat-option value="alarmaD">Alarmas Dispositivos</mat-option>
                <mat-option value="alarmaT">Alarmas Tanques</mat-option>
                <mat-option value="desconectado">Desconectado</mat-option>
            </mat-select>
        </mat-form-field>

        <!--LEYENDA-->
        <button mat-button [matMenuTriggerFor]="menu" class="leyenda-menu-button">
            Leyenda
            <mat-icon>help_outline</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <mat-list role="list" class="lista-menu-leyenda">
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <mat-icon class="simbolo-alarma-leyenda color-negro">signal_wifi_off</mat-icon>
                    <span class="leyenda-text color-negro">Dispositivo sin conexión</span>
                </mat-list-item>
                <mat-divider class="divider"></mat-divider> 
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <mat-icon class="simbolo-alarma-leyenda color-negro">sd_card</mat-icon>
                    <span class="leyenda-text color-negro">Fallo en la MicroSD</span>
                </mat-list-item>
                <mat-divider class="divider"></mat-divider> 
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <mat-icon class="simbolo-alarma-leyenda color-negro">power_off</mat-icon>
                    <span class="leyenda-text color-negro">Se fue la corriente</span>
                </mat-list-item>
                <mat-divider class="divider"></mat-divider> 
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <mat-icon class="simbolo-alarma-leyenda color-negro">lightbulb</mat-icon>
                    <span class="leyenda-text color-negro">Ha vuelto la corriente</span>
                </mat-list-item>
                <mat-divider class="divider"></mat-divider>
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <mat-icon class="simbolo-alarma-leyenda color-negro">local_drink</mat-icon>
                    <span class="leyenda-text color-negro">Nivel del tanque bajo</span>
                </mat-list-item>
                <mat-divider class="divider"></mat-divider>
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <mat-icon class="simbolo-alarma-leyenda color-negro">whatshot</mat-icon>
                    <span class="leyenda-text color-negro">Temperatura alta en tanque</span>
                </mat-list-item>
                <mat-divider class="divider"></mat-divider>
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <mat-icon class="simbolo-alarma-leyenda color-negro">ac_unit</mat-icon>
                    <span class="leyenda-text color-negro">Temperatura baja en tanque</span>
                </mat-list-item>
                <mat-divider class="divider"></mat-divider>
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <mat-icon class="simbolo-alarma-leyenda color-negro">arrow_circle_up</mat-icon>
                    <span class="leyenda-text color-negro">Presion alta en tanque</span>
                </mat-list-item>
                <mat-divider class="divider"></mat-divider>
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <mat-icon class="simbolo-alarma-leyenda color-negro">arrow_circle_down</mat-icon>
                    <span class="leyenda-text color-negro">Presion baja en tanque</span>
                </mat-list-item>
            </mat-list>
        </mat-menu>

        <!--COLORES-->
        <!--<button mat-button [matMenuTriggerFor]="menu1" class="leyenda-menu-button">
            Colores
            <mat-icon>help_outline</mat-icon>
        </button>
        <mat-menu #menu1="matMenu">
            <mat-list role="list" class="lista-menu-leyenda">
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <div class="leyenda-info-colors">
                        <div class="color-square backgground-color-negro"></div>
                        <span class="leyenda-text color-negro">Funcionando correctamente</span>
                    </div>
                </mat-list-item>
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <div class="leyenda-info-colors">
                        <div class="color-square backgground-color-gris"></div>
                        <span class="leyenda-text color-gris">Dispositivo sin conexión</span>
                    </div>
                </mat-list-item>
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <div class="leyenda-info-colors">
                        <div class="color-square backgground-color-amarillo"></div>
                        <span class="leyenda-text color-amarillo">Alarma de dispositivo</span>
                    </div>
                </mat-list-item>
                <mat-list-item role="listitem" class="list-item-leyenda">
                    <div class="leyenda-info-colors">
                        <div class="color-square backgground-color-rojo"></div>
                        <span class="leyenda-text color-rojo">Alarma de tanque</span>
                    </div>
                </mat-list-item>
            </mat-list>
        </mat-menu>-->

        <!--RECARGAR TANQUES-->
        <!-- <button 
            *ngIf="userData.pro_id == 4 || userData.pro_id == 2"
            mat-button class="cargar-tanques-button"
            matBadge="{{dispositivosConAlarmasNivel.length}}" 
            matBadgeColor="warn"
            matBadgeSize="medium"
            [matBadgeHidden]="dispositivosConAlarmasNivel.length === 0"
            [ngClass]="{
                'no-tanks': dispositivosConAlarmasNivel.length === 0,
                'yes-tanks': dispositivosConAlarmasNivel.length !== 0,
              }"
            (click)="abrirDialogoTanques('400ms','200ms')">
            <mat-icon>autorenew</mat-icon>
            Recargar tanques
        </button> -->

        <!--Primer Paginator-->
        <!--<mat-paginator *ngIf="(datosRecibidos2) && errorMessage === '' && nDispositivos !==0"
            class="paginator-1"
            [length]="nDispositivos"
            [pageSize]="pageSize"
            [pageIndex]="currentPage"
            [pageSizeOptions]="[20, 40, 80]"
            (page)="onPageChange($event)"
            [disabled]="!datosRecibidos2">
        </mat-paginator>-->
    </div>
</div>

<ng-container *ngIf="!(datosRecibidos2) && errorMessage === ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <span class="wait-message">Cargando datos...</span>
            <mat-progress-bar mode="indeterminate" class="progress-bar" color="warn"></mat-progress-bar>
        </div>
    </div>
</ng-container>

<ng-container *ngIf="errorMessage !== ''">
    <div class="wait-top-container">
        <div class="wait-container">
            <div class="wait-message">{{ errorMessage }}</div>
        </div>
    </div>
</ng-container>

                <!--[ngClass]="{
                    'panel-tittle-alarm-OO': getDeviceWithAlarmOO(item.id),
                    'panel-tittle-alarm-dispositivo': existeAlarmaEnDispositvo(item.id),
                    'panel-tittle-alarm-tanque': existeAlarmaEnTanque(item.id),
                    'panel-tittle-alarm': existeAlarmaEnDispositvo(item.id) && existeAlarmaEnTanque(item.id)
                }"-->

<ng-container *ngIf="(datosRecibidos2) && errorMessage === ''">
    <ng-container *ngFor="let item of visibleDevices; let i = index">
        <mat-expansion-panel disabled hideToggle [expanded]="opened[i] && verificarExistenciaHistorial(deviceHistoryMap,item.dev_reference)" class="mat-elevation-z4">
            <mat-expansion-panel-header>
                <mat-panel-title class="background" [attr.nonce]="cspNonce">
                    <div class="device-information">
                        <span class="dev-label">{{ item.dev_label }}&nbsp;</span> 
                        <span class="dev-reference">(ID: {{ item.dev_reference }})</span>
                        <ng-container *ngFor="let tipoAlarma of item.tiposDeAlarma">
                            <mat-icon *ngIf="tipoAlarma === 'OO'" class="simbolo-alarma">signal_wifi_off</mat-icon>
                            <mat-icon *ngIf="tipoAlarma === 'EE'" class="simbolo-alarma">sd_card</mat-icon>
                            <mat-icon *ngIf="tipoAlarma === 'TT'" class="simbolo-alarma">power_off</mat-icon>
                            <mat-icon *ngIf="tipoAlarma === 'RR'" class="simbolo-alarma">lightbulb</mat-icon>
                            <mat-icon *ngIf="['L1', 'L2', 'L3', 'L4'].includes(tipoAlarma)" class="simbolo-alarma">local_drink</mat-icon>
                            <mat-icon *ngIf="['A1', 'A2', 'A3', 'A4'].includes(tipoAlarma)" class="simbolo-alarma">whatshot</mat-icon>
                            <mat-icon *ngIf="['B1', 'B2', 'B3', 'B4'].includes(tipoAlarma)" class="simbolo-alarma">ac_unit</mat-icon>
                            <mat-icon *ngIf="['C1', 'C2', 'C3', 'C4'].includes(tipoAlarma)" class="simbolo-alarma">arrow_circle_up</mat-icon>
                            <mat-icon *ngIf="['D1', 'D2', 'D3', 'D4'].includes(tipoAlarma)" class="simbolo-alarma">arrow_circle_down</mat-icon>
                        </ng-container>
                        <span class="aditional-information">
                            Última lectura: {{getUltimaLectura(item.id)}}
                        </span>
                        <span class="tanque-activo" *ngIf="verificarExistenciaHistorial(deviceHistoryMap,item.dev_reference)">
                            Tanque activo: {{getTanqueActivo(item.id)}}
                        </span>
                    </div>
                    <button mat-icon-button [matMenuTriggerFor]="menu" class="more-vert-btn">
                        <mat-icon>more_vert</mat-icon>
                    </button>
                </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-menu #menu="matMenu">
                <button mat-menu-item routerLink="/dispositivo/ver/{{item.id}}">
                    <mat-icon>info</mat-icon>
                    <span>Ver detalles</span>
                </button>
                <button mat-menu-item routerLink="/{{item.id}}/editar/dispositivo">
                    <mat-icon>settings</mat-icon>
                    <span>Editar configuración</span>
                </button>
                <button mat-menu-item (click)="togglePanel(i)" *ngIf="verificarExistenciaHistorial(deviceHistoryMap,item.dev_reference)">
                    <mat-icon>{{ !opened[i] ? 'arrow_downward' : 'hide_source' }}</mat-icon>
                    <span>{{ !opened[i] ? 'Mostrar' : 'Ocultar' }}</span>
                </button>
            </mat-menu>

            <mat-toolbar class="device-graphs">
                <div class="grafico-T">
                    <h6 class="titulo-nombre-T margin-top" 
                        [ngStyle]="{'color': getColorTemperatura(item)}" 
                        [attr.nonce]="cspNonce">
                        <b class="inline-block" [ngStyle]="{'text-decoration': getColorTemperatura(item) === 'black' ? 'none' : 'underline'}" [attr.nonce]="cspNonce">
                            Temperatura 
                            <p class="exclamacion">
                                {{ getColorTemperatura(item) === 'black' ? '' : '!' }}
                            </p>
                        </b>
                    </h6>
                    <div class="container margin-left1" *ngIf="verificarExistenciaHistorial(deviceHistoryMap,item.dev_reference)">
                        <p>ºC</p>
                    </div>
                    <div class="g-T">
                        <canvas id="{{item.dev_reference}}T"></canvas>
                    </div>
                </div>        
                <div class="grafico-P">
                    <h6 class="titulo-nombre-P margin-top" 
                        [ngStyle]="{'color': getColorPresion(item)}"
                        [attr.nonce]="cspNonce" >
                        <b class="inline-block" [ngStyle]="{'text-decoration': getColorPresion(item) === 'black' ? 'none' : 'underline'}" [attr.nonce]="cspNonce">
                            Presion 
                            <p class="exclamacion">
                                {{ getColorPresion(item) === 'black' ? '' : '!' }}
                            </p>
                        </b>
                    </h6>
                    <div class="container margin-left2" *ngIf="verificarExistenciaHistorial(deviceHistoryMap,item.dev_reference)">
                        <p>Bares</p>
                    </div>
                    <div class="g-P"> 
                        <canvas id="{{item.dev_reference}}P"></canvas>
                    </div>
                </div>
                <div class="grafico-NC">
                    <h6 class="titulo-nombre-NC margin-top" 
                        [ngStyle]="{'color': getColorNivelConsumo(item)}" 
                        [attr.nonce]="cspNonce">
                        <b class="inline-block" [ngStyle]="{'text-decoration': getColorNivelConsumo(item) === 'black' ? 'none' : 'underline'}" [attr.nonce]="cspNonce">
                            Nivel/Consumo 
                            <p class="exclamacion">
                                {{ getColorNivelConsumo(item) === 'black' ? '' : '!' }}
                            </p>
                        </b>
                    </h6>
                    <div *ngIf="verificarExistenciaHistorial(deviceHistoryMap,item.dev_reference)" class="nivel-consumo-labels">
                        <div class="container margin-left3">
                            <p>Nivel (L)</p>
                        </div>
                        <div class="consumo">
                            <p>Consumo (L)</p>
                        </div>
                    </div>
                    <div class="g-NC">
                        <canvas id="{{item.dev_reference}}NC"></canvas>
                    </div>
                </div>
            </mat-toolbar>
        </mat-expansion-panel>
    </ng-container>
</ng-container>

<!--Segundo Paginator-->
<ng-container *ngIf="(datosRecibidos2) && errorMessage === '' && nDispositivos !==0">
        <mat-paginator class="paginator-2"
        [length]="nDispositivos"
        [pageSize]="pageSize"
        [pageIndex]="currentPage"
        [pageSizeOptions]="[20, 40, 80]"
        (page)="onPageChange($event)"
        [disabled]="!datosRecibidos2">
    </mat-paginator>
</ng-container>


